import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { FileUpload as FileUploadComp } from '@src/common/FileUploadV2';
import { Card } from '@uhg-abyss/web/ui/Card';
import { StateSelect } from '../Inputs/StateSelect/StateSelect';
import { City } from '../Inputs/City';
import { ZipCode } from '../Inputs/ZipCode';
import { StreetLine } from '../Inputs/StreetLine';

const Upload = styled('div', {
  '& [data-testid*="remove-icon"]': {
    marginLeft: '15%',
  },
});

const AlignZip = styled('div', {
  marginLeft: '10px',
});

const Space = styled('div', {
  marginBottom: '16px',
});

const Text = styled('p', {
  lineHeight: '22px',
});

const RemoveIcon = styled('span', {
  fontSize: 'initial',
  fontWeight: 'bold',
  float: 'right',
  marginRight: '25px',
  cursor: 'pointer',
  color: '$accent1',
});

const AlignRemoveText = styled('span', {
  marginLeft: '2px',
  verticalAlign: 'text-bottom',
});

export const SecondaryServicing = ({
  index,
  addressCount,
  handleRemoveSecondaryAddress,
}) => {
  return (
    <PageLayout>
      <Card
        header={
          <React.Fragment>
            Secondary servicing Address ({index + 1} of {addressCount})
            <RemoveIcon onClick={handleRemoveSecondaryAddress}>
              <IconSymbol icon="delete" size="18px" />
              <AlignRemoveText>Remove</AlignRemoveText>
            </RemoveIcon>
          </React.Fragment>
        }
      >
        <Card.Section>
          <Text>
            Provide the secondary servicing address for your practice.
          </Text>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id={`address-secondary-servicing-${index}-street-line-1-input`}
                model={`address.secondaryServicing[${index}].streetLine1`}
                label="Street line 1"
                streetLine="1"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id={`address-secondary-servicing-${index}-street-line-2-input`}
                model={`address.secondaryServicing[${index}].streetLine2`}
                label="Street line 2"
                streetLine="2"
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <City
                id={`secondary-servicing-${index}address-city-input`}
                model={`address.secondaryServicing[${index}].city`}
                label="City"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <Layout.Group>
                <StateSelect
                  model={`address.secondaryServicing[${index}].state`}
                  id={`address-secondaryServicing${index}-state-select`}
                  required
                />
                <AlignZip>
                  <ZipCode
                    id={`secondary-servicing-${index}-address-zipCode-input`}
                    model={`address.secondaryServicing[${index}].zipCode`}
                    label="ZIP Code"
                    required
                  />
                </AlignZip>
              </Layout.Group>
            </Space>
          </Grid.Col>
          <Grid.Col span="100%" css={{ padding: '0px' }}>
            <Upload>
              <FileUploadComp
                id={`upload-secondary-servicing-${index}-address-proof-input`}
                model={`address.secondaryServicing[${index}].proof`}
                label="Proof of servicing address"
                required
              />
            </Upload>
          </Grid.Col>
        </Card.Section>
      </Card>
    </PageLayout>
  );
};

SecondaryServicing.propTypes = {
  index: PropTypes.number.isRequired,
  addressCount: PropTypes.number.isRequired,
  handleRemoveSecondaryAddress: PropTypes.func.isRequired,
};
